<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      <h4 class="my-0">
        {{ $t("navigations.critical datapoints") }}
      </h4>
    </template>
    <template #body>
        <div class="table-responsive custom-dark-table-wrapper">
        <template v-if="criticalDataPoints.length == 0">
            <div class="text-center">
              <div>
                {{ $t("navigations.please wait while the list is being loaded") }}
              </div>
            </div>
        </template>
        <table v-else class="table table-striped dark-table-head mb-0">
            <thead>
                <tr>
                    <th> {{ $t("navigations.risk id") }} </th>
                    <th> {{ $t("navigations.risk name") }} </th>
                    <th> {{ $t("navigations.unit") }} </th>
                    <th> {{ $t("navigations.version") }} </th>
                    <th> {{ $t("navigations.critical points") }} </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in criticalDataPoints" :key="item.id">
                    <td> {{  item.riskID }}</td>
                    <td> {{  item.riskName }}</td>
                    <td> {{  item.unit }}</td>
                    <td> {{  item.version }}</td>
                    <td class="text-center"> 
                        <div class="position-relative cursor-pointer"
                            @click="showCriticalDP(item)">
                            <i class="fa fa-ellipsis-v"></i>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>  
    </template>
  </customModal>
  <CriticalDPModal
        v-if="showCriricalPopUp"
        :criticalInfo="dpPayload"
        formPage="ThresholdPopup"
        @closeModal="closeCriticalDataPopup"
   />
  <ThresholdInfoPopup
    v-if="showThreshold"
    :ThresholdDetails="thresholdDetails"
    @closeModal="closeThresholdInfo"
 />
</template>

<script src="./ThresholdPopup.js"></script>

<style scoped>

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}
.thead-primary {
  background-color: #0095ff !important;
  color: #ffffff !important;
}
.table-hover tbody tr:hover {
  background-color: rgba(209, 236, 255, 0.05);
}
.dark-table-head > thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}
.dark-table-head thead th {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>